/* global localStorage */
import { getImageOnlyHitHTML } from '../listing_tile_rendering/listingTileUtils'
import { buildFilters, initiateSearch } from '../../utils/search/helpers'
import { getLocaleFromPath, prependLocale } from '../../utils/localeHelpers'
import { onVisible } from '../utils'

export default function initRecentModules () {
  loadRecentListings()
  loadRecentSearches()
}

function loadRecentListings () {
  const recentSectionContainers = document.querySelectorAll('.vjs-algolia-recent-section')

  recentSectionContainers.forEach(container => {
    if (container.dataset.lazyLoaded === 'true') {
      onVisible(container, loadItemsIntoContainer)
    } else {
      loadItemsIntoContainer(container)
    }
  })
}

function loadItemsIntoContainer (container) {
  const { hitsPerPage, listingIds } = container.dataset
  const recentListingsFilters = buildFilters({ listingIds })
  const nodeEnv = process.env.NODE_ENV

  initiateSearch(recentListingsFilters, `Listing_${nodeEnv}`).then(results => {
    const hits = results.hits.slice(0, hitsPerPage)

    if (hits.length < 1) {
      container.parentElement?.remove()
    } else {
      const queryID = results.queryID ? results.queryID : ''
      hits.forEach((hit, index) => {
        hit.__position = index + 1
        hit.__queryID = queryID
      })

      renderImageOnlyListingTiles(container, hits)
    }
  })
}

function renderImageOnlyListingTiles (placeholderElement, hits, tileOptions = {}) {
  const hitsHtml = hits.map(hit => getImageOnlyHitHTML(hit, tileOptions))
  placeholderElement.innerHTML = hitsHtml.join('')
}

// Shared with welcomeRecentSearchMatches so "same list as the banner" holds by
// construction. Returns the locale (from the path) and the stored searches
// (newest first), each shaped `{ id, label }`.
export function readRecentSearches () {
  const locale = getLocaleFromPath(window.location.pathname)
  const storageKey = locale ? `AUTOCOMPLETE_RECENT_SEARCHES:RECENT_SEARCH_${locale}` : 'AUTOCOMPLETE_RECENT_SEARCHES:RECENT_SEARCH'
  const recentSearchesVal = localStorage.getItem(storageKey)
  if (!recentSearchesVal) return { locale, searches: [] }

  try {
    const searches = JSON.parse(recentSearchesVal)
    return { locale, searches: Array.isArray(searches) ? searches : [] }
  } catch {
    return { locale, searches: [] }
  }
}

function loadRecentSearches () {
  const { locale, searches } = readRecentSearches()
  if (searches.length === 0) return

  const listElement = document.getElementById('vjs-recent-queries')
  if (!listElement) return

  searches.slice(0, 5).forEach((search, index) => {
    const listItem = document.createElement('li')
    const anchor = document.createElement('a')
    anchor.href = prependLocale(`/search?q=${encodeURIComponent(search.id)}`, locale)
    anchor.textContent = search.label
    anchor.target = '_blank'
    anchor.classList.add('text-midnight-black', 'hover:text-midnight-black', 'text-size-xxsm', 'max-887:text-size-sm')
    listItem.appendChild(anchor)
    listItem.classList.add('flex', 'items-center', 'h-full', 'max-w-[140px]', 'overflow-hidden', 'whitespace-nowrap', 'text-ellipsis', 'underline-offset-4')
    if (index >= 3) listItem.classList.add('max-480:hidden')
    listElement.appendChild(listItem)
  })
  const listElementWrapper = document.getElementById('vjs-recent-queries-wrapper')
  listElementWrapper.classList.remove('hidden')
}
